import client from "./client";

const endpoint = "member";

const getMember = () => client.get(`${endpoint}`);

const updateMember = ({ body }) => client.put(`${endpoint}`, body);

const getReservedFlights = () => client.get(`${endpoint}/all-reservations`);

const getReservedFlightByRecord = ({ recordLocator }) =>
  client.get(`${endpoint}/reservation/${recordLocator}`);

const getSavedTravelers = (params = {}, config = {}) => {
  const search = typeof params === "object" ? params.search : params;
  const term = (search || "").trim();
  const query = term ? `?search=${encodeURIComponent(term)}` : "";
  return client.get(`${endpoint}/travelers${query}`, undefined, config);
};

export {
  getMember,
  updateMember,
  getReservedFlights,
  getReservedFlightByRecord,
  getSavedTravelers,
};
